import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Inject,
  Input, OnInit,
  Output,
  Renderer2
} from '@angular/core';
import { FormioCustomComponent } from '@evi-ui/angular';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { FormioEvent } from '@evi-ui/angular/elements.common';
import { HttpClient } from '@angular/common/http';
import { EventType } from '../../model/event.data';
import { EventBusService } from '../../event-bus.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { LodashTemplateEvaluator } from '../smart-table/LodashTemplateEvaluator';
import { FormRendererUtils } from '../../../portal/application-forms/all-forms-renderer/form-renderer-utils';

@Component({
  selector: 'vector-checkbox',
  templateUrl: './vector-checkbox.component.html',
  styleUrls: ['./vector-checkbox.component.scss']
})
export class VectorCheckboxComponent implements FormioCustomComponent<string>, OnInit
{
  destroyRef = inject(DestroyRef);
  @Input() propertyName: string;
  @Input() imageKey: string;
  @Input() apiKey: string = '';

  private _value: any = {};
  @Input()
  public set value(val: any) {
    if (!val) {
      return;
    }
    this._value = val;
  }

  public get value() {
    return this._value;
  }

  @Input() label: string;

  @Output() formioEvent?: EventEmitter<FormioEvent>;
  @Input() disabled: boolean = false;

  @Input() initialValueEvaluator?: string;
  private _form: any;
  private formioInstance: any;

  @Input() aclResource: string = '';
  @Output() valueChange = new EventEmitter<any>();

  imageToUse: any;

  static readonly currentChecked: string[] = [];

  constructor(
    private readonly router: Router,
    private readonly eventBusService: EventBusService,
    private readonly renderer2: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly http: HttpClient,
    private readonly elRef: ElementRef,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
    this.eventBusService
      .on(EventType.FORM_READY)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (
          _.isUndefined(formData) ||
          formData == null ||
          _.isUndefined(this.propertyName)
        )
          return;
        this._form = formData;
        this.formioInstance = formData;
      });

    this.eventBusService
      .on(EventType.FORM_DATA_LOADED)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (
          _.isUndefined(formData) ||
          formData == null ||
          _.isUndefined(this.propertyName)
        )
          return;
        this._form = formData;

        if (
          this.initialValueEvaluator?.trim().length
        ) {
          let actionValue = LodashTemplateEvaluator.interpolate(
            this.initialValueEvaluator,
            this._form
          );
          let checkedValue = FormRendererUtils.evaluate(
            actionValue,
            this._form,
            'value'
          );
          if (checkedValue) {
            VectorCheckboxComponent.currentChecked.push(this.aclResource);
          }
        }
        this.changeDetectorRef.detectChanges();
      });
  }

  ngOnInit() {
    this.imageToUse = '/assets/vector-checkbox/' + this.imageKey;
  }


  onCheckBoxChange(event: any) {
    const isChecked = event.target.checked;
    this.toggleCheck(isChecked);
    if (isChecked) {
      if (!VectorCheckboxComponent.currentChecked.includes(this.aclResource)) {
        VectorCheckboxComponent.currentChecked.push(this.aclResource);
      }
    } else {
      const index = VectorCheckboxComponent.currentChecked.indexOf(this.aclResource);
      if (index > -1) {
        VectorCheckboxComponent.currentChecked.splice(index, 1);
      }
    }
  }

  toggleCheck(shouldCheck = false) {
    _.set(
      this.formioInstance?.submission?.data,
      this.apiKey,
      shouldCheck ? this.aclResource : ''
    );
  }

  get aclArray() {
    return VectorCheckboxComponent.currentChecked;
  }
}
